<script>
  import Vue from 'vue'
  let vm = new Vue()
  export default vm
</script>



// WEBPACK FOOTER //
// channel.vue?ca30836a